import { useCallback, useEffect, useState } from 'react'

import useTotalStakingPower from './useTotalStakingPower'
import useBlockNum from '../bakery/useBlockNum'
import { BigNumber } from '../../sushi'
import { NFTTYPE } from '../../constants/bakery/nft'
import { 
  getMasterChefContract,
  getMasterChef2Contract,
  getComboNFTCommonStakeERC721EarnBake3Address, 
  getPoolWeight, 
  getDishStakingPowerTokenAddress,
  getTokenPerBlock 
} from '../../sushi/utils'
import useYam from '../bakery/useYam'
import { userBakeContractVersion } from '../../userType/userBakeContractVersion'

const useRoi = (currentBlock: number, stakingPowerMultiple: number, type?: string) => {
  const [roi, setRoi] = useState<BigNumber>()
  const bakeContractVersion = userBakeContractVersion(type)
  const totalStakingPower = useTotalStakingPower(currentBlock,type)

  const sushi = useYam()
  let masterChefContract = getMasterChefContract(sushi)
  let dishStakingPowerTokenAddress = getDishStakingPowerTokenAddress(sushi)
  switch (type) {
    case NFTTYPE.COMBO_V3:
      dishStakingPowerTokenAddress = getComboNFTCommonStakeERC721EarnBake3Address(sushi)
      break
    case NFTTYPE.COMBO:
      dishStakingPowerTokenAddress = getDishStakingPowerTokenAddress(sushi)
      break
  }
  let blockNum:any = useBlockNum(currentBlock)

  const calculateRoi = useCallback(async () => {
    if(bakeContractVersion === 'v2'){
      masterChefContract = getMasterChef2Contract(sushi)
      dishStakingPowerTokenAddress = getComboNFTCommonStakeERC721EarnBake3Address(sushi)
      blockNum = await getTokenPerBlock(masterChefContract)
      blockNum = new BigNumber(blockNum) || new BigNumber(0)
      blockNum = blockNum.div(new BigNumber(10).pow(18))
    }
    if (totalStakingPower && blockNum) {
      const poolWeight = await getPoolWeight(masterChefContract, dishStakingPowerTokenAddress)
      const roi =
        stakingPowerMultiple && totalStakingPower.isFinite()
          ? blockNum
              .times(poolWeight)
              .times(28800)
              .times(365)
              .times(new BigNumber(stakingPowerMultiple).div(100000).div(totalStakingPower))
          : new BigNumber(0)
      setRoi(roi)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sushi, masterChefContract, stakingPowerMultiple, blockNum, totalStakingPower])

  useEffect(() => {
    if (sushi && masterChefContract && totalStakingPower && blockNum) {
      calculateRoi()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sushi, masterChefContract, stakingPowerMultiple, blockNum, totalStakingPower])

  return roi
}

export default useRoi
